



























import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import CustomerNew from '@/components/Customer/CustomerNew.vue';

@Component({
  components: {
    CustomerNew,
  },
})
export default class CustomerNewButton extends Vue {
  @Prop(Boolean) private dimmer?: boolean;
  public showDialog = false;

  @Emit()
  public customerCreated() {
    this.showDialog = false;
  }
}
